import { constants } from '@bedc/constants';

import { Request as BaseRequest } from '../../../../api/generic/search/Request';

import { SearchDataTableType } from './SearchDataTableType';

export const WoHUsageType = SearchDataTableType({
	request: BaseRequest({
		sortFields: constants.wholeHouse.usage.sortFields,
		columnFields: constants.wholeHouse.usage.columnFields,
		standardFilterFields: constants.wholeHouse.usage.osStandardFilterFields,
		dateFilterFields: constants.wholeHouse.usage.osDateFilterFields,
		stageStatusFilterFields: [] as const,
		booleanFilterFields: [] as const,
	}),
	columnFields: constants.wholeHouse.usage.columnFields,
	filterIds: constants.wholeHouse.usage.filterFields,
});
